import * as React from 'react';
import { useBooleanState } from '@cian/react-utils';
import { Button, ISuggestionItem as IUIKitSuggestionItem, Input, Suggest, useDeviceType } from '@cian/ui-kit';

import { IconActionSearch16 } from '@cian/ui-kit-design-tokens/icons';

import { useEmptyListText, useSuggestions, useDebouncedValueEffect } from './hooks';
import { RightAdornmentContainer } from './parts/RightAdornmentContainer';
import { trackPromoSearchSelect } from './tracking';
import { SearchSuggestAdornment } from '../../components/SearchSuggest';

export const SearchSuggestContainer: React.FC = () => {
  const deviceType = useDeviceType();

  const { state: open, setFalse: closeSuggest, setTrue: openSuggest } = useBooleanState();
  const [value, setValue] = React.useState('');

  const suggestions = useSuggestions(value);
  const isDebouncing = useDebouncedValueEffect(value, openSuggest, closeSuggest);
  const emptyListText = useEmptyListText(value, isDebouncing);

  const selectItem = React.useCallback(
    (item: IUIKitSuggestionItem<string>) => {
      closeSuggest();
      window.open(item.value, '_blank');
      trackPromoSearchSelect();
      setValue('');
    },
    [closeSuggest],
  );

  return (
    <Suggest
      suggestions={suggestions}
      emptyListText={emptyListText}
      open={open}
      onClose={closeSuggest}
      onSelect={selectItem}
      showEmptySuggest
      title="Поиск акций"
    >
      {deviceType === 'desktop' || open ? (
        <Input
          size="M"
          placeholder="Найти ЖК, банк, застройщика"
          value={value}
          onChange={(_event, value) => setValue(value)}
          leftAdornment={<SearchSuggestAdornment icon={<IconActionSearch16 />} />}
          rightAdornment={
            <RightAdornmentContainer
              suggestionsLength={suggestions.length}
              valueLength={value.length}
              onClearClick={() => setValue('')}
            />
          }
          data-testid="SearchSuggestInput"
        />
      ) : (
        <Button
          beforeIcon={<IconActionSearch16 color="icon-main-default" />}
          theme="fill_white_primary"
          onClick={openSuggest}
          aria-label="Поиск акций"
          data-testid="SearchSuggestButton"
          size="XS"
        />
      )}
    </Suggest>
  );
};
